<template>
  <v-card class="bs-shadow-none">
    <div class="pa-4 pa-md-6">
      <v-form @submit.prevent="verifyAccount" ref="form">
        <h3 class="mb-3">Verify</h3>
        <p class="grey--text mb-4 mb-md-6">
          You're about to verify {{ fund_data.account_number }}, please confirm to
          proceed.
        </p>
        <div class="d-flex justify-end bs-gap-2 mt-4 mt-md-6">
          <v-btn text depressed @click="closeDialog()" :disabled="loading">Cancel</v-btn>
          <v-btn color="primary" dark depressed :loading="loading" type="submit"
            >Confirm</v-btn
          >
        </div>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import response_post from "@/helpers/api_request_post.js";

export default {
  data: () => ({
    loading: false,
  }),
  props: {
    fund_data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async verifyAccount() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const form_data = new FormData();
        form_data.append("bank_id", this.fund_data.account_id);
        form_data.append("player_id", this.fund_data.player_id);
        form_data.append("reason", this.reason);

        const res = await response_post(form_data, "bank_account/verify");

        this.$emit("send_message", {
          type: "verify",
          status: res.data.status,
          message: res.data.message,
        });

        this.loading = false;
      }
    },
    closeDialog() {
      this.$emit("close_dialog", "verify");
    },
  },
};
</script>
